import { FC } from 'react'
import { Typography, useTheme } from '@mui/material'
import { Table } from '../../../../../components/Table'

const Table_Headers = ['STATE', 'PUBLIC SYSTEM', 'DISTANCE FROM ZIP CODE']

const Table_Data = [
  {
    state: 'Alabama',
    waterSystemCount: 816,
    distanceFromZipCode: 382,
  },
  {
    state: 'Alaska',
    waterSystemCount: 740,
    distanceFromZipCode: 12,
  },
  {
    state: 'Arizona',
    waterSystemCount: 113998,
    distanceFromZipCode: 295,
  },
  {
    state: 'Arkansas',
    waterSystemCount: 137732,
    distanceFromZipCode: 400,
  },
]

const headerCells = Table_Headers.map((header, index) => ({
  content: (
    <Typography
      key={index}
      color="secondary"
      fontSize="0.8rem"
      textAlign={index > 0 ? 'right' : 'left'}
    >
      {header}
    </Typography>
  ),
}))

export const PublicWaterSystemTable: FC = () => {
  const theme = useTheme()

  const rows: any = Table_Data.map((rowCell) => {
    const cells = [
      {
        content: (
          <Typography
            color="secondary"
            fontSize="0.875rem"
          >
            {rowCell.state}
          </Typography>
        )
      },
      {
        content: (
          <Typography
            color="secondary"
            fontSize="0.875rem"
          >
            {rowCell.waterSystemCount}
          </Typography>
        ),
        cellProps: {
          sx: { textAlign:'right' },
        },
      },
      {
        content: (
          <Typography
            color="secondary"
            fontSize="0.875rem"
          >
            {rowCell.distanceFromZipCode}
          </Typography>
        ),
        cellProps: {
          sx: { textAlign:'right' },
        },
      },
    ]

    return {
      rowProps: {
        sx: { '&:hover': { cursor: 'pointer', background: theme.palette.background.default } },
      },
      cells,
    }
  })

  return (
    <Table
      containerProps={{
        sx: {
          boxShadow: 'none',
          background: 'transparent',
        },
      }}
      head={{
        containerProps: {
        sx: { borderRadius: '8px', background: theme.palette.grey[100], width: '100%' },
        },
        rows: [{ cells: headerCells }],
      }}
      body={{ rows }}
    />
  )
}
